// @flow
import React from 'react';
import { Slider } from 'components/atoms/slider';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  min: number,
  max: number,
  values?: Array<number>,
  onChange: (value: number) => void,
};

export const RangeFilter = (props: Props) => {
  const { min, max, values, onChange } = props;

  return (
    <div className={'range-filter filter inline'}>
      <h5 className={'filter-title'}>Price Range Per Month</h5>
      <div className={'filter-options'}>
        <Slider
          type={'range'}
          min={min}
          max={max}
          onChange={onChange}
          values={values}
          showTooltip={true}
          step={1}
          tooltipFormatter={v => `${v}`}
        />
      </div>
    </div>
  );
};
